<template>
    <div class="content-body">
        <div class="content-inside">
            <b-form>
                <b-row class="mt-1">
                    <b-col sm="12">
                        <p>Update your CMS password here.</p>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col sm="12" md="2">
                        <h6 class="align-middle">Password</h6>
                    </b-col>
                    <b-col sm="12" md="7">
                        <b-row>
                            <b-col cols="4">
                                <b-form-group label="Old Password" label-for="oldPassword" class="sl-helper"
                                    :invalid-feedback="errorMessage('oldpassword')" :state="isValid('oldpassword')">

                                    <b-form-input id="oldPassword" type="password" placeholder="" v-model="form.oldPassword"
                                        ref="oldPassword">
                                    </b-form-input>

                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="4">
                                <b-form-group label="New Password" label-for="newPassword" class="sl-helper"
                                    :invalid-feedback="errorMessage('password')" :state="isValid('password')">

                                    <b-form-input id="newPassword" type="password" placeholder="" v-model="form.newPassword"
                                        ref="newPassword">
                                    </b-form-input>

                                </b-form-group>
                            </b-col>
                            <b-col cols="4">
                                <b-form-group label="Confirm New Password" label-for="confirmPassword" class="sl-helper"
                                    :invalid-feedback="errorMessage('password_confirmation')"
                                    :state="isValid('password_confirmation')">

                                    <b-form-input id=confirmPassword type="password" placeholder=""
                                        v-model="form.confirmPassword" ref="confirmPassword">
                                    </b-form-input>

                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="9">
                        <hr>
                    </b-col>
                    <b-col></b-col>
                </b-row>
                <b-row>
                    <b-col><b-button size="lg" variant="primary" class="save-button mt-4" @click="updatePassword"
                            :disabled="loading">
                            <span v-if="loading">Loading...</span>
                            <span v-else>Update</span>
                        </b-button></b-col>
                    <b-col cols="10"></b-col>
                </b-row>
            </b-form>

        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "security",

    data() {
        return {
            env: process.env.VUE_APP_MODE,
            form: {
                oldPassword: null,
                newPassword: null,
                confirmPassword: null
            }
        };
    },

    computed: {
        ...mapState("accountSecurity", ["errors", "passwordUpdated", "loading"]),
        ...mapState("auth", ["hasPasswordUpdated", "user", "currentStep"])
    },
    // beforeCreate() {
    //     console.log(this.hasPasswordUpdated);
    // },

    // created() {

    // },
    beforeRouteEnter(to, from, next) {
        next(vm => {

            if (from.name == "login" && (vm.hasPasswordUpdated == 1 || vm.hasPasswordUpdated == true)) {
                next({ path: '/account/profile' })
            }
        })
    },
    methods: {
        updatePassword: async function () {
            this.$store.commit("accountSecurity/setDetails", this.form);
            this.$store.dispatch("accountSecurity/resetErrors");
            await this.$store
                .dispatch("accountSecurity/updateDetails")
                .then(() => {
                    if (this.errors == null) {
                        this.form = {
                            oldPassword: null,
                            newPassword: null,
                            confirmPassword: null
                        }
                        this.$store.dispatch("auth/getMerchant");
                        this.$store.dispatch("auth/getUserDetails");
                    }
                });
            if (this.env === 'Production')
                this.$ga.event('CMS Change Pass', 'click', this.user.uuid, 1);

        },
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }

            return this.errors.errors[field];
        },
        isValid(field) {
            if (this.errors == null) {
                return false;
            }
            return this.errors.errors[field] ? false : true;
        }
    },
};
</script>

<style lang="scss" scoped>
h5 {
    font-size: 16px;
}

h6 {
    font-family: MainFontBold, sans-serif;
    font-size: 16px;
}
</style>
